"use client";
import TestimonialSlide from "./testimonialSlide";
import { StarIcon } from "@heroicons/react/20/solid";
import { useKeenSlider } from "keen-slider/react";
import "keen-slider/keen-slider.min.css";

const TestimonialSlider = () => {
  const [sliderRef] = useKeenSlider<HTMLDivElement>({
    loop: true,
    mode: "free-snap",
    slides: { perView: 1.2, spacing: 25 },
    breakpoints: {
      "(min-width: 390px)": {
        slides: { perView: 1.25, spacing: 25 },
      },
      "(min-width: 512px)": {
        slides: { perView: 1.5, spacing: 25 },
      },
      "(min-width: 875px)": {
        slides: { perView: 1.8, spacing: 25 },
      },
      "(min-width: 1024px)": {
        slides: { perView: 2.3, spacing: 25 },
      },
      "(min-width: 1280px)": {
        slides: { perView: 3, spacing: 25 },
      },
    },
  });

  return (
    <div ref={sliderRef} className="keen-slider text-white">
      <div className="keen-slider__slide number-slide1">
        <TestimonialSlide
          title="Incluso Services do care"
          icon={StarIcon}
          quote="When we most needed the help of someone that our son would actually trust and bond with Incluso services did it with open arms and hearts, this in itself shows that Incluso Services do care for the health and wellbeing of people in need."
          author="Rachael"
        />
      </div>
      <div className="keen-slider__slide number-slide2">
        <TestimonialSlide
          title="The team genuinely care"
          icon={StarIcon}
          quote="Incluso Services provides in-home care to my son and I couldn’t be more happy. The team genuinely care and they have formed such a great bond with him that he  genuinely looks forward to his carers arriving."
          author="Frank"
        />
      </div>
      <div className="keen-slider__slide number-slide3">
        <TestimonialSlide
          title="The genuine care and support"
          icon={StarIcon}
          quote="The genuine care and support offered by Incluso came with a warmth and understanding we've not experienced any where else. I highly recommend the incredible team at Incluso."
          author="Andy"
        />
      </div>
    </div>
  );
};

export default TestimonialSlider;
